import { render, staticRenderFns } from "./Currencies.vue?vue&type=template&id=2dbd7084&scoped=true"
import script from "./Currencies.vue?vue&type=script&lang=js"
export * from "./Currencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbd7084",
  null
  
)

export default component.exports